
import { defineComponent } from "vue";
export default defineComponent({
  name: "MarksInputComponent",
  props: {
    modelValue: {
      type: Number,
      default: 0,
      required: true,
    },
    courseUsed: Boolean,
  },
  data() {
    return { valid: true };
  },
  emits: ["update:modelValue"],
  watch: {
    modelValue() {
      //Validate
      if (this.modelValue > 15 || this.modelValue < 0) {
        this.valid = false;
      } else {
        this.valid = true;
      }
    },
  },
  methods: {
    preventNonNumValues(e: KeyboardEvent) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
  },
});
